// removed by extract-text-webpack-plugin
module.exports = {"carriers-carousel":"src-components----CarriersCarousel-module---carriers-carousel---2Pukn","tape":"src-components----CarriersCarousel-module---tape---1-ilE","logo":"src-components----CarriersCarousel-module---logo---16jeJ"};


//////////////////
// WEBPACK FOOTER
// ./src/components/CarriersCarousel.module.scss
// module id = 651
// module chunks = 35783957827783